import { reactive } from 'vue'
import { MSAL } from './msal'
import { MSALBasic, Options } from './msalTypes'

export const msalPlugin = {
  install: (app: any, options: Options) => {
    const msal = new MSAL(options)
    const msalBasic: MSALBasic = reactive({
      data: msal.data,
      async login() {
        await msal.login()
      },
      async logout() {
        await msal.logout()
      },
      isAuthenticated() {
        return msal.isAuthenticated()
      },
      async acquireToken(request) {
        return await msal.acquireToken(request)
      },
      async initialize() {
        await msal.initialize()
      },
      async handleRedirect() {
        await msal.handleRedirect()
      },
      async userUpdates(request) {
        return await msal.userUpdates(request)
      }
    })

    app.config.globalProperties.$msal = msalBasic
    app.config.globalProperties.msal = reactive(msal.data)

    app.provide('MSAL', msalBasic)
  }
}
